// extracted by mini-css-extract-plugin
module.exports = {"gradientLight6":"#d7e3e6","lightShadow3":"0 0 8px 0.5px rgba(0, 0, 0, 0.045)","container":"TableWithCustomColumns__container","table":"TableWithCustomColumns__table"};